"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextBox = _interopRequireDefault(require("../TextBox/TextBox"));
var _List = _interopRequireDefault(require("../List/List"));
var _PageAccordionGeneric = _interopRequireDefault(require("../PageAccordionGeneric/PageAccordionGeneric"));
var _removeTags = require("../../../common/removeTags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-legalpolicy .legalpolicy-accordion-container .bx--accordion__heading:focus::before {\n  border-width: 0px; }\n\n.sia-legalpolicy .legalpolicy-accordion-container .bx--accordion__heading:hover::before {\n  opacity: 0.3; }\n\n.sia-legalpolicy .legalpolicy-accordion-container .bx--accordion__title {\n  color: #e41b13;\n  font-family: 'Helvetica Neue LT Roman';\n  font-size: 16px; }\n  .sia-legalpolicy .legalpolicy-accordion-container .bx--accordion__title .first-word {\n    margin-right: 2px; }\n\n.sia-legalpolicy .legalpolicy-accordion-container .bx--accordion__content {\n  padding-right: 64px; }\n\n.sia-legalpolicy .legalpolicy-accordion-container .accordion-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px; }\n  .sia-legalpolicy .legalpolicy-accordion-container .accordion-content .item {\n    display: flex;\n    gap: 16px; }\n    .sia-legalpolicy .legalpolicy-accordion-container .accordion-content .item .icon-container > svg {\n      color: #e41b13;\n      margin-top: -4px; }\n    .sia-legalpolicy .legalpolicy-accordion-container .accordion-content .item .text-container {\n      display: flex;\n      flex-direction: column;\n      gap: 16px; }\n      .sia-legalpolicy .legalpolicy-accordion-container .accordion-content .item .text-container .downloadlinkbox-container {\n        padding-left: 0px; }\n      .sia-legalpolicy .legalpolicy-accordion-container .accordion-content .item .text-container .downloadlink-container {\n        padding-bottom: 0px; }\n\n.sia-legalpolicy .textBox-container,\n.sia-legalpolicy .list-container {\n  padding-right: 0px; }\n\n.sia-legalpolicy .list-container {\n  padding-bottom: 32px; }\n\n@media (max-width: 66rem) {\n  .sia-legalpolicy .link,\n  .sia-legalpolicy .accordion-container {\n    padding-inline: 16px; }\n  .sia-legalpolicy .legalpolicy-accordion-container .bx--accordion__content {\n    padding-right: 32px; } }\n";
  const fileName = "LegalPolicyArticle_LegalPolicyArticle";
  const element = document.querySelector("style[data-sass-component='LegalPolicyArticle_LegalPolicyArticle']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Item = _ref => {
  let {
    item,
    lang
  } = _ref;
  const paragraph = item?.text_box_elements;
  if (item.paragraph_type === 'text_box_col') {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: paragraph,
      className: "sia-text-10"
    }, /*#__PURE__*/_react.default.createElement(_TextBox.default, {
      items: item.text_box_elements,
      lang: lang
    }));
  }
  if (item.paragraph_type === 'list') {
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      title: item.title || '',
      items: item.paragraph_multi?.map(el => {
        return {
          content: el
        };
      }),
      variant: item.list_type.name.toUpperCase()
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
const Children = _ref2 => {
  let {
    element,
    ...rest
  } = _ref2;
  if (element.children?.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, element.children.map((el, index) => {
      const className = element.index.toString().split('.').length > 1 ? 'sia-margin-04-left' : '';
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        className: className
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "sia-text-04"
      }, element.index, ".", index + 1, " ", el.title), /*#__PURE__*/_react.default.createElement(Content, _extends({
        key: index,
        content: el.article_element,
        element: {
          ...el,
          index: `${element.index}.${index + 1}`
        }
      }, rest)));
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
const Content = _ref3 => {
  let {
    content,
    element,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Children, _extends({
    element: element
  }, rest)), content.map((contentElement, index) => {
    return /*#__PURE__*/_react.default.createElement(Item, _extends({
      key: index,
      item: contentElement
    }, rest));
  }));
};
const LegalPolicyArticle = _ref4 => {
  let {
    article,
    lang,
    history
  } = _ref4;
  (0, _react.useEffect)(() => {
    function firstWordFromClassName(elements) {
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (el.innerHTML.indexOf('</span>') < 0) {
          const splitWords = el.innerHTML.split(' ');
          const secondWord = el.innerHTML.substr(el.innerHTML.indexOf(' '));
          el.innerHTML = `<span class='first-word'>${splitWords[0]}</span>
            ${secondWord}`;
        }
      }
    }
    setTimeout(() => {
      const elements = document.getElementsByClassName('bx--accordion__title');
      if (elements) firstWordFromClassName(elements);else {
        setTimeout(() => {
          const elements = document.getElementsByClassName('bx--accordion__title');
          if (elements) firstWordFromClassName(elements);
        }, 500);
      }
    }, 500);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "legalpolicy-accordion-container sia-margin-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_PageAccordionGeneric.default, {
    item: {
      accordion_generic_element: article?.map((el, index) => {
        return {
          col_0: el.article_element,
          accordion_generic_el_title: [`${index + 1}  ${(0, _removeTags.removeTags)(el.title)}`],
          children: el.children,
          index: index + 1
        };
      })
    },
    lang: lang,
    Item: Item,
    history: history,
    Content: Content
  }));
};
LegalPolicyArticle.propTypes = {
  article: _propTypes.default.array.isRequired
};
var _default = exports.default = LegalPolicyArticle;